import castArray from "lodash/fp/castArray";
import flatMap from "lodash/fp/flatMap";
import flow from "lodash/fp/flow";
import get from "lodash/fp/get";
import keyBy from "lodash/fp/keyBy";
import includes from "lodash/fp/includes";
import isNil from "lodash/fp/isNil";
import map from "lodash/fp/map";
import mapValues from "lodash/fp/mapValues";
import merge from "lodash/fp/merge";
import omitBy from "lodash/fp/omitBy";
import pick from "lodash/fp/pick";

import getFieldsToUpdate from "./getFieldsToUpdate";
import { getDefaultValues } from "./getSelectedProductStateValues";

export default function getNextUserChoiceValues({ product, userChoiceValues }) {
  return (action) => {
    const willResetToDefaultValues =
      ["ProCustomGoalierGear2023", "DigiPrintGoalieGear2024"].includes(
        product.id
      ) &&
      flow(castArray, map(get("name")), includes("graphic"))(action.payload);

    const valuesToUpdate = flow(
      get("payload"),
      castArray,
      keyBy("name"),
      mapValues(get("value"))
    )(action);

    const defaultValues = getDefaultValues({
      product,
      userChoiceValuesToUpdate: valuesToUpdate,
    });

    if (willResetToDefaultValues) {
      // Return default values but keep users selection of which goalie-gear to customise and also the 'custom-level' value stored in initialUserChoiceValues in JSON.
      return {
        ...defaultValues,
        ...pick([
          "custom-level",
          "customise-pads",
          "customise-glove",
          "customise-blocker",
        ])(userChoiceValues),
      };
    }

    return flow(
      get("payload"),
      castArray,
      flatMap(({ name, value }) =>
        getFieldsToUpdate({
          name,
          value,
          customisations: product.customisations,
          userChoiceValues,
        })
      ),

      // apply any default values to null values
      map((field) => {
        if (isNil(field.value) && !isNil(defaultValues[field.name])) {
          return { ...field, value: defaultValues[field.name] };
        }
        return field;
      }),

      keyBy("name"),
      mapValues(get("value")),
      merge(userChoiceValues),
      omitBy(isNil)
    )(action);
  };
}
